export default __webpack_public_path__ + "static/media/failure-img.531745eb.png";